import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01f0bd4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed inset-0 z-[9999] flex items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-black/50" }, null, -1))
const _hoisted_3 = { class: "relative z-10" }
const _hoisted_4 = { class: "w-[90%] h-full self-center flex flex-col" }
const _hoisted_5 = { class: "text-v_dark_blue text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "mt-4",
  style: {"border-top-width":"3px"}
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5 text-base text-gray-700 space-y-4 leading-relaxed flex-1 overflow-y-auto pr-2" }, [
  /*#__PURE__*/_createElementVNode("p", null, " O portal de comissões foi atualizado para integração com o novo ERP. Essa mudança garante mais segurança no processo de solicitação e pagamento das comissões. "),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-yellow-100 border-l-4 border-yellow-500 p-4 rounded" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-yellow-800" }, [
      /*#__PURE__*/_createTextVNode(" Para comissões oriundas da empresa "),
      /*#__PURE__*/_createElementVNode("strong", null, "Prime Interway"),
      /*#__PURE__*/_createTextVNode(", a emissão da nota fiscal deverá ocorrer somente após a solicitação do Pedido de Compra (PC). ")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, " Este novo fluxo se aplica exclusivamente a essas comissões. "),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
      /*#__PURE__*/_createTextVNode(" Para comissões da "),
      /*#__PURE__*/_createElementVNode("strong", null, "RB Code"),
      /*#__PURE__*/_createTextVNode(", o processo permanece conforme o modelo anterior. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mt-4" }, "Novo fluxo:"),
    /*#__PURE__*/_createElementVNode("ol", { class: "list-decimal ml-6 mt-3 space-y-2" }, [
      /*#__PURE__*/_createElementVNode("li", null, "Selecione as comissões desejadas"),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode("Clique em "),
        /*#__PURE__*/_createElementVNode("strong", null, "Enviar")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, "Escolha o código de serviço"),
      /*#__PURE__*/_createElementVNode("li", null, "Aguarde a solicitação do Pedido de Compra (PC)"),
      /*#__PURE__*/_createElementVNode("li", null, "Emita a nota fiscal com base nas informações do PC"),
      /*#__PURE__*/_createElementVNode("li", null, "Retorne ao portal e anexe a nota fiscal")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col text-gray-700 space-y-1" }, [
      /*#__PURE__*/_createElementVNode("p", null, " Para mais informações, baixe o documento completo. "),
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Em caso de dúvidas, acesse a aba "),
        /*#__PURE__*/_createElementVNode("strong", null, "\"Dúvidas\""),
        /*#__PURE__*/_createTextVNode(" no portal e entre em contato com nosso suporte. ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "flex md:justify-end" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "/docs/novas_regras_prime_interway.pdf",
        download: "",
        class: "bg-v_dark_blue text-white px-5 py-2 rounded hover:opacity-90 transition whitespace-nowrap"
      }, " Baixar documento completo ")
    ])
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "mt-4",
  style: {"border-top-width":"3px"}
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "agree-checkbox"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3 text-base" }, "Li e concordo com as novas regras", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "mt-4",
  style: {"border-top-width":"3px"}
}, null, -1))
const _hoisted_13 = { class: "mt-4 flex justify-center items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "continue-text" }, "Continuar", -1))

import {
	ref,
} from "vue"
import {
	ModalContainer,
	H1,
	ModalButton,
	ModalContentContainer,
} from "../atoms"


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertNewFlowModal',
  emits: [
	"enableLoading",
	"successSeeingAlert",
],
  setup(__props, { emit }) {

let showButton = ref(false)


const handleButton = () => {
	showButton.value = true
}

const closeAlert = async () => {
	showButton.value = false
	emit("enableLoading", true)
	emit("successSeeingAlert")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ModalContainer), null, {
        default: _withCtx(() => [
          _createVNode(_unref(ModalContentContainer), {
            width: 18,
            h: "83vh",
            style: {"padding-top":"1rem","padding-bottom":"1rem"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(H1), null, {
                    default: _withCtx(() => [
                      _createTextVNode("Atenção")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createElementVNode("div", { class: "flex items-center mt-4" }, [
                  _createElementVNode("label", {
                    class: "flex items-center w-full cursor-pointer",
                    onClick: handleButton
                  }, _hoisted_11)
                ]),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(ModalButton), {
                    disabled: !_unref(showButton),
                    class: "active:scale-90 px-6 py-2",
                    enableButton: _unref(showButton),
                    onClick: closeAlert
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["disabled", "enableButton"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})